@if(isLoading) {
  <app-loading-page [message]="'Verifying deployment in progress'"></app-loading-page>
}
@else {
  <app-hot-glue
    [linkedSources]="false"
    (scriptLoaded)="onScriptLoaded()"
  ></app-hot-glue>
}